import React from "react";

export default function ProductDetailSkeleton() {
  return (
    <div className="product-detail-skeleton">
      <div className="skeleton-header">
        <div className="skeleton-line short" />
        <div className="skeleton-line medium" />
      </div>
      <div className="skeleton-tabs">
        <div className="skeleton-line pill" />
        <div className="skeleton-line pill" />
        <div className="skeleton-line pill" />
      </div>
      <div className="skeleton-content">
        <div className="skeleton-card">
          <div className="skeleton-line" />
          <div className="skeleton-line medium" />
          <div className="skeleton-line short" />
        </div>
        <div className="skeleton-chart">
          <div className="skeleton-line" style={{ height: "200px" }} />
        </div>
      </div>
    </div>
  );
}
